'use client';
import { throttle } from '@/utils';
import { Image, Select, SelectItem } from '@nextui-org/react';
import Link from 'next/link';
import { Fragment, useCallback, useEffect, useState, useRef } from 'react';
import raf from 'rc-util/lib/raf';

interface IProps {
  list: {
    title: string;
    id: string;
    children?: {
      title: string;
      id: string;
    }[]
  }[]
}

function easeInOutCubic(t: number, b: number, c: number, d: number) {
  const cc = c - b;
  // biome-ignore lint: it is a common easing function
  t /= d / 2;
  if (t < 1) {
    return (cc / 2) * t * t * t + b;
  }
  // biome-ignore lint: it is a common easing function
  return (cc / 2) * ((t -= 2) * t * t + 2) + b;
}
//  TODO 最下面到底部出现多个章节的情况，需要判断一下，然后划到底部就是最后一个，还有从底部网上滑动的解决办法
function getViewIndex(nodePosition: number[], documentY: number, screenHeight: number, maxHeight: number) {
  const idPos = nodePosition.map((item, index) => {
    if (index === 0) {
      return [0, nodePosition[index + 1]];
    }
    if (index === nodePosition.length - 1) {
      return [item, maxHeight];
    }
    return [item, nodePosition[index + 1]];
  });
  return Math.max(idPos.findIndex(item => (item[1] > (documentY) && item[0] <= (documentY))), 0);
}

function scrollTo(y: number, cb: () => void) {
  console.log('Toc.tsx/(y):', y);
  const  duration = 200;
  // const scrollTop = window.pageYOffset;
  const startTime = Date.now();

  const frameFunc = () => {
    const timestamp = Date.now();
    const time = timestamp - startTime;
    const scrollTop = window.pageYOffset;
    const nextScrollTop = easeInOutCubic(time > duration ? duration : time, scrollTop, y, duration);
    window.scrollTo(window.pageXOffset, nextScrollTop);
    const isEnd  = Math.abs(document.documentElement.scrollHeight - document.documentElement.clientHeight - document.documentElement.scrollTop) < 1;
    const isDownEnd = isEnd && y > scrollTop; 
    // if (time < duration) {
    // 滑动到页面最大高度也算结束
    // 24148 24148 23697 23697 451
    if ( Math.abs( y - scrollTop) > 10 && !isDownEnd) {
      raf(frameFunc);
    } else if (typeof cb === 'function') {
      console.log('---end', document.documentElement.scrollTop);
      cb();
    }
  };
  raf(frameFunc);
  // let timer = setTimeout(() => {

  // }, 100);
}

export default function Toc(props: IProps) {

  const [activeTitle, setActiveTitle] = useState('');

  const canScroll = useRef(true);

  const [selectChapter, setSelectChapter] = useState(props.list?.find(item => item.id === 'summary')?.children?.[0]?.id);

  const scrollToId = useCallback((id: string) => {
    canScroll.current = false;
    const target = document.getElementById(id);
    if (!target) return;
    // target.scrollIntoView({ behavior: 'smooth' });
    window.location.replace(`#${id}`);
    const y = target?.getBoundingClientRect().top! + (document.documentElement.scrollTop || document.body.scrollTop);
    // const scrollTop = window.pageYOffset;
    scrollTo( y, () => {
      setActiveTitle(id);
      // console.log('------target', y )
      // console.log('---------end1' , document.documentElement.scrollTop)
      let tim = setTimeout(() => {
        canScroll.current = true;
        // console.log('---------end2', document.documentElement.scrollTop)
        clearTimeout(tim);
      }, 100);
    });
  }, []);

  const handleScroll = useCallback(() => {
    if (!canScroll.current) return;
    const nodeList = props.list.map((item) => {
      return document.getElementById(item.id);
    });
    const nodePostion = nodeList.map(node => node?.getBoundingClientRect().top! + (document.documentElement.scrollTop || document.body.scrollTop));
    const documentY = document.documentElement.scrollTop;
    // console.log('Toc.tsx/(d...ntY):', documentY)
    // console.log('Toc.tsx/(n...ion):', nodePostion)
    // let idx = nodePostion.findIndex((node => node >= (documentY - 40)));
    let idx = getViewIndex(nodePostion, documentY, window.innerHeight, document.documentElement.scrollHeight);
    // console.log('Toc.tsx/(idx):', idx)
    if (idx === -1) {
      const len = nodePostion.length;
      idx = documentY > nodePostion[len - 1] ? len - 1 : idx;
    }
    setActiveTitle(props.list[idx].id);
  }, [props.list]);


  const handleSelectChange = useCallback((e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    setSelectChapter(value);
    setActiveTitle(value);
    document.getElementById(value)?.scrollIntoView();
  }, []);

  useEffect(() => {
    const hash = location.hash;
    if (hash.length > 1) {
      setActiveTitle( decodeURI(hash.substring(1)));
    }
  }, [props.list]);

  useEffect(() => {

    const fn = throttle(() => {
      handleScroll();
    }, 100);
    fn();
    window.addEventListener('scroll', fn, false);
    return () => {
      window.removeEventListener('scroll', fn, false);
    };

  }, [handleScroll, canScroll]);


  return (
    <div>
      <h2 className='text-[#191300] text-20-27 font-semibold text-center'>Table of Contents</h2>
      <ul>
        {
          props.list.map((item) => {
            return (
              <Fragment key={item.id}>
                <li className={` ${activeTitle === item.id ? 'text-[#0032B3]' : 'text-[#191300]'} flex items-center pl-[5px]  text-14-19 font-medium pt-4`}>
                  <Image alt='li' src='/toc-right.png' width={12} height={12} radius='none' />
                  <Link
                    href={`#${item.id}`}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToId(item.id);
                    }}
                  >
                    {item.title}
                  </Link>
                </li>
                {
                  item.children ?
                    <Select
                      className='pl-[17px] pt-4'
                      aria-label='select'
                      classNames={{
                        mainWrapper: 'bg-opacity-0',
                        trigger: 'bg-opacity-0 border-1 border-[#E5E5E5] rounded-[3px] data-[hover=true]:bg-opacity-0',
                      }}
                      selectedKeys={[selectChapter || '']}
                      onChange={handleSelectChange}
                    >
                      {
                        item.children.map(child => {
                          return (
                            <SelectItem key={child.id}>{child.title}</SelectItem>
                          );
                        })
                      }
                    </Select>
                    : null
                }
              </Fragment>
            );
          })
        }
      </ul>

    </div>
  );
}
